import { supabase } from '@/integrations/supabase/client';

export const settingsService = {
  // Get submission deadline
  async getSubmissionDeadline(): Promise<Date> {
    console.log('📅 Fetching submission deadline from database');
    
    const { data, error } = await supabase
      .from('app_settings')
      .select('value')
      .eq('key', 'submission_deadline')
      .single();

    if (error) {
      console.error('❌ Error fetching deadline:', error);
      // Fallback to default date if database query fails
      return new Date('2026-04-15T23:59:59');
    }

    console.log('✅ Deadline fetched:', data?.value);
    return new Date(data.value);
  }
};
